/** @jsx jsx */
import React from "react"
import { Heading, Flex, jsx } from "theme-ui"

interface SectionHeaderProps {
  children: React.ReactNode
  noBorder: boolean
}

const SectionHeader = (props: SectionHeaderProps) => {
  const { children, noBorder } = props
  return (
    <Flex
      mb={2}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        ...(noBorder
          ? {}
          : {
              "::before": {
                content: '""',
                borderBottom: "1px solid #000",
                width: "200px",
                marginRight: 4,
                display: ["none", "block"],
              },
              "::after": {
                content: '""',
                width: "200px",
                borderBottom: "1px solid #000",
                marginLeft: 4,
                display: ["none", "block"],
              },
            }),
      }}
    >
      <Heading variant="caps" sx={{ fontSize: [2, null, 5] }}>
        {children}
      </Heading>
    </Flex>
  )
}

SectionHeader.defaultProps = {
  noBorder: false,
}

export default SectionHeader
